
        // Import dependencies
        import { gsap } from 'gsap';
        import { ScrollTrigger } from 'gsap/ScrollTrigger';
        import { Flip } from 'gsap/Flip';
        import Lenis from '@studio-freight/lenis';
        
        // Register GSAP plugins
        gsap.registerPlugin(ScrollTrigger, Flip);
        
        // Make GSAP and Lenis available globally for page-specific scripts
        window.gsap = gsap;
        window.ScrollTrigger = ScrollTrigger;
        window.Flip = Flip;
        window.Lenis = Lenis;
        
        console.log('✅ GSAP and Lenis loaded globally');
    